export default __webpack_public_path__ + "a14e76014767f1860bf146acc8983adb.png";